import i18n from "@mirage/translations";
import { OnboardingSurveyQuestionFieldType } from "../types";

import type { OnboardingSurveyQuestion } from "../types";

export enum ProfilingQuestionCompanySize {
  JustMe = "Just me",
  TwoToNineteen = "2-19",
  TwentyToNinetyNine = "20-99",
  OneHundredToTwoFourtyNine = "100-249",
  TwoHundredFiftyToOneThousand = "250-1000",
  OverOneThousand = "1000+",
}

export enum ProfilingQuestionJobsToBeDoneAnswer {
  SummarizeFiles = "summarize_files",
  Search = "search",
  WriteBetter = "write_better",
  NotSure = "not_sure",
}

export enum ProfilingQuestionKindOfWorkAnswer {
  Creative = "creative",
  EngineeringProductDesign = "engineering_product_design",
  FinancialOrStrategicAdvisor = "financial_or_strategic_advisor",
  HumanResources = "human_resources",
  InformationTechnology = "information_technology",
  Marketing = "marketing",
  Operations = "operations",
  Sales = "sales",
  Other = "other",
}

export enum ProfilingQuestionIndustryAnswer {
  ArchitectureEngineeringConstruction = "architecture_engineering_construction",
  CapitalMarkets = "capital_markets",
  Education = "education",
  FinancialServices = "financial_services",
  Government = "government",
  Healthcare = "healthcare",
  Manufacturing = "manufacturing",
  MediaOrSports = "media_or_sports",
  ProfessionalServices = "professional_services",
  Technology = "technology",
  Other = "other",
}

const KIND_OF_WORK_QUESTION: OnboardingSurveyQuestion = {
  questionId: "KIND_OF_WORK_V1",
  questionType: OnboardingSurveyQuestionFieldType.Select,
  label: i18n.t("self_serve_profiling_kind_of_work_question"),
  isTeamBased: false,
  questionValues: [
    {
      label: i18n.t("self_serve_profiling_kind_of_work_answer_creative"),
      value: ProfilingQuestionKindOfWorkAnswer.Creative,
    },
    {
      label: i18n.t(
        "self_serve_profiling_kind_of_work_answer_engineering_product_design",
      ),
      value: ProfilingQuestionKindOfWorkAnswer.EngineeringProductDesign,
    },
    {
      label: i18n.t(
        "self_serve_profiling_kind_of_work_answer_financial_or_strategic_advisor",
      ),
      value: ProfilingQuestionKindOfWorkAnswer.FinancialOrStrategicAdvisor,
    },
    {
      label: i18n.t("self_serve_profiling_kind_of_work_answer_human_resources"),
      value: ProfilingQuestionKindOfWorkAnswer.HumanResources,
    },
    {
      label: i18n.t(
        "self_serve_profiling_kind_of_work_answer_information_technology",
      ),
      value: ProfilingQuestionKindOfWorkAnswer.InformationTechnology,
    },
    {
      label: i18n.t("self_serve_profiling_kind_of_work_answer_marketing"),
      value: ProfilingQuestionKindOfWorkAnswer.Marketing,
    },
    {
      label: i18n.t("self_serve_profiling_kind_of_work_answer_operations"),
      value: ProfilingQuestionKindOfWorkAnswer.Operations,
    },
    {
      label: i18n.t("self_serve_profiling_kind_of_work_answer_sales"),
      value: ProfilingQuestionKindOfWorkAnswer.Sales,
    },
    {
      label: i18n.t("self_serve_profiling_other_answer"),
      value: ProfilingQuestionKindOfWorkAnswer.Other,
    },
  ],
};

export const ADMIN_PROFILING_QUESTIONS: OnboardingSurveyQuestion[] = [
  {
    questionId: "COMPANY_SIZE_V1",
    label: i18n.t("self_serve_profiling_company_size_question"),
    questionType: OnboardingSurveyQuestionFieldType.ChipList,
    isTeamBased: true,
    questionValues: [
      {
        label: i18n.t("self_serve_profiling_just_me"),
        value: ProfilingQuestionCompanySize.JustMe,
      },
      {
        label: i18n.t("self_serve_profiling_number_range", {
          start: 2,
          end: 19,
        }),
        value: ProfilingQuestionCompanySize.TwoToNineteen,
      },
      {
        label: i18n.t("self_serve_profiling_number_range", {
          start: 20,
          end: 99,
        }),
        value: ProfilingQuestionCompanySize.TwentyToNinetyNine,
      },
      {
        label: i18n.t("self_serve_profiling_number_range", {
          start: 100,
          end: 249,
        }),
        value: ProfilingQuestionCompanySize.OneHundredToTwoFourtyNine,
      },
      {
        label: i18n.t("self_serve_profiling_number_range", {
          start: 250,
          end: 1000,
        }),
        value: ProfilingQuestionCompanySize.TwoHundredFiftyToOneThousand,
      },
      {
        label: i18n.t("self_serve_profiling_number_range_over_1000"),
        value: ProfilingQuestionCompanySize.OverOneThousand,
      },
    ],
  },
  {
    questionId: "INDUSTRY_V1",
    questionType: OnboardingSurveyQuestionFieldType.Select,
    label: i18n.t("self_serve_profiling_industry_question"),
    isTeamBased: true,
    questionValues: [
      {
        label: i18n.t(
          "self_serve_profiling_industry_answer_architecture_engineering_construction",
        ),
        value:
          ProfilingQuestionIndustryAnswer.ArchitectureEngineeringConstruction,
      },
      {
        label: i18n.t("self_serve_profiling_industry_answer_capital_markets"),
        value: ProfilingQuestionIndustryAnswer.CapitalMarkets,
      },
      {
        label: i18n.t("self_serve_profiling_industry_answer_education"),
        value: ProfilingQuestionIndustryAnswer.Education,
      },
      {
        label: i18n.t(
          "self_serve_profiling_industry_answer_financial_services",
        ),
        value: ProfilingQuestionIndustryAnswer.FinancialServices,
      },
      {
        label: i18n.t("self_serve_profiling_industry_answer_government"),
        value: ProfilingQuestionIndustryAnswer.Government,
      },
      {
        label: i18n.t("self_serve_profiling_industry_answer_healthcare"),
        value: ProfilingQuestionIndustryAnswer.Healthcare,
      },
      {
        label: i18n.t("self_serve_profiling_industry_answer_manufacturing"),
        value: ProfilingQuestionIndustryAnswer.Manufacturing,
      },
      {
        label: i18n.t("self_serve_profiling_industry_answer_media_or_sports"),
        value: ProfilingQuestionIndustryAnswer.MediaOrSports,
      },
      {
        label: i18n.t(
          "self_serve_profiling_industry_answer_professional_services",
        ),
        value: ProfilingQuestionIndustryAnswer.ProfessionalServices,
      },
      {
        label: i18n.t("self_serve_profiling_industry_answer_technology"),
        value: ProfilingQuestionIndustryAnswer.Technology,
      },
      {
        label: i18n.t("self_serve_profiling_other_answer"),
        value: ProfilingQuestionIndustryAnswer.Other,
      },
    ],
  },
  {
    ...KIND_OF_WORK_QUESTION,
  },
  {
    questionId: "IS_IT_ADMIN_V1",
    isTeamBased: false,
    questionType: OnboardingSurveyQuestionFieldType.ChipList,
    label: i18n.t("self_serve_profiling_it_admin_question"),
    questionValues: [
      {
        label: i18n.t("onboarding_survey_answer_yes"),
        value: "true",
      },
      {
        label: i18n.t("self_serve_profiling_it_admin_answer_no"),
        value: "false",
      },
    ],
  },
];

export const TEAM_MEMBER_PROFILING_QUESTIONS: OnboardingSurveyQuestion[] = [
  {
    ...KIND_OF_WORK_QUESTION,
  },
  {
    questionId: "TITLE_V1",
    questionType: OnboardingSurveyQuestionFieldType.ChipList,
    isTeamBased: false,
    label: i18n.t("self_serve_profiling_manage_access_question"),
    questionValues: [
      {
        label: i18n.t("onboarding_survey_answer_yes"),
        value: "true",
      },
      {
        label: i18n.t("self_serve_profiling_manage_access_no"),
        value: "false",
      },
    ],
  },
  {
    questionId: "JOBS_TO_BE_DONE_V1",
    questionType: OnboardingSurveyQuestionFieldType.ChipList,
    isTeamBased: false,
    label: i18n.t("self_serve_profiling_title_jobs_to_be_done_question"),
    questionValues: [
      {
        label: i18n.t("self_serve_profiling_jtbd_find_things_fast"),
        value: ProfilingQuestionJobsToBeDoneAnswer.Search,
      },
      {
        label: i18n.t("self_serve_profiling_jtbd_summarize_files"),
        value: ProfilingQuestionJobsToBeDoneAnswer.SummarizeFiles,
      },
      {
        label: i18n.t("self_serve_profiling_jtbd_write_better"),
        value: ProfilingQuestionJobsToBeDoneAnswer.WriteBetter,
      },
      {
        label: i18n.t("self_serve_profiling_jtbd_not_sure_yet"),
        value: ProfilingQuestionJobsToBeDoneAnswer.NotSure,
      },
    ],
  },
];
